<template>
  <div>
    <b-modal
        :id="id"
        :hide-footer="hideDefaultFooter"
        @close="$emit('close')"
    >
      <template
          #modal-title
          v-if="modalTitle"
      >
        {{modalTitle}}
      </template>

      <slot name="modal-content" />

      <slot name="modal-footer"
          v-if="hideDefaultFooter"
      />
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'VModal',
  props: {
    hideDefaultFooter: {
      type: Boolean,
      default: false,
    },
    modalTitle: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      required: true,
    },
  },
}
</script>
